/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Stress_LabelInputs */

const en_us2_workout_stress_label = /** @type {(inputs: Workout_Stress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stress today`)
};

const pt_br2_workout_stress_label = /** @type {(inputs: Workout_Stress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estresse hoje`)
};

const es_419_workout_stress_label = /** @type {(inputs: Workout_Stress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrés hoy`)
};

const pt_pt2_workout_stress_label = /** @type {(inputs: Workout_Stress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stress hoje`)
};

const fr_fr2_workout_stress_label = /** @type {(inputs: Workout_Stress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stress aujourd'hui`)
};

const de_de2_workout_stress_label = /** @type {(inputs: Workout_Stress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stress heute`)
};

const it_it2_workout_stress_label = /** @type {(inputs: Workout_Stress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stress oggi`)
};

/**
* | output |
* | --- |
* | "Stress today" |
*
* @param {Workout_Stress_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_stress_label = /** @type {((inputs?: Workout_Stress_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Stress_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_stress_label(inputs)
	if (locale === "es-419") return es_419_workout_stress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_stress_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_stress_label(inputs)
	if (locale === "de-DE") return de_de2_workout_stress_label(inputs)
	if (locale === "it-IT") return it_it2_workout_stress_label(inputs)
	return en_us2_workout_stress_label(inputs)
});
export { workout_stress_label as "workout.stress_label" }